import {useEffect, useRef, useState} from "react";
import {RedeemGrid} from "./Redeem.styled";
import {useStore} from "@store/appStore";
import db from "@utils/db";
import Cross_Icon from '@assets/svg/match/missing.svg'
import RainbowLoader from "@components/Loaders/RainbowLoader";
import { useI18n } from '@i18n/useI18n';
import ManagementSide from "./ManagementSide";
import RewardSide from "./RewardSide";
import SearchBar from "./SearchBar";
import StatsDash from "./StatsDash";

interface IProps{

}

const Redeem = (props:IProps) =>{
    const i18n = useI18n();
    const { adminSelection, adminSelectedStudent} = useStore();
    const [student, setStudent] = useState(null)
    const [log, setLog] = useState(null)
    const inputRef = useRef(null)
    const [stats, setStats] = useState(null)

    useEffect(() => {
        getData()
    }, [])

    useEffect(() => {
        if (adminSelection && adminSelection.type === "STUDENT" && (student && student.id !== adminSelection.id || student === null))
        {
            getStudent()

        }
        else if(!adminSelection || adminSelection.type === null && student && student.id !== null)
        {
            setStudent(null)
            getData()
        }
    }, [adminSelection])

    const getData = async () => {
        getLog()
        getStats()
    }

    const getStats = async () => {
        let stats = await db.GetTransactionLog_Stats()
        setStats(stats)
    }

    const getLog = async () => {
        let log = await db.GetTransactionLog_CoinsAllStudents(1, 50)
        setLog(log)
    }

    const getStudent = async () => {
        let coins = await db.Student_Stat_GetCoins(adminSelection.val, true)        
        let c = 0
        db.GetTransactionLog_Coins(adminSelection.id, 1).then(logs => {
            if (coins.length > 0)
            {
                c = Number(coins[0].oldcoins === null?0:coins[0].oldcoins)  + Number(coins[0].newcoins === null?0:coins[0].newcoins)
            }
            setStudent({id: adminSelection.id, coins: c, name: adminSelectedStudent.firstname, logs: logs, username: adminSelection.val})
        })
    }

    return (
        <RedeemGrid>
            <SearchBar student={student} />
            {student ?
            <>
                <ManagementSide updatestudent={getStudent} student={student} />
                <RewardSide updatestudent={getStudent} student={student} />
            </>
            : 
                <StatsDash />
            }
        </RedeemGrid>
    )
}

export default Redeem;